module.exports = __webpack_public_path__ + "static/media/sewaDiwasEvent.14809815.jpg";